require('./gridDataBrowser.i18n.json');
require('./gridDataBrowser.less');
require('./gridDataBrowser.tpl.html');
require('./gridDataBrowserController.js');

const GridDataBrowserComponent = {
    templateUrl: '/gridDataBrowser.tpl.html',
    controller: 'gridDataBrowserController',
    bindings: {
        identifier: '<',
        columns: '<',
        stateParams: '<',
        advancedFilterType: '<',
        filterType: '<',
        translations: '<',
        initialRequestParams: '<',
        loadFilterHandler: '<',
        loadItemsHandler: '<',
        loadActionsHandler: '<',
        notifyHandleAction: '&',
        notifyHandleBulkAction: '&',
        showSelector: '<',
        singleSelect: '<'
    }
};

angular.module('gw-um-grid-data-browser')
    .component('uiGridDataBrowser', GridDataBrowserComponent);
